import { memo } from "react";
import styled from "styled-components";
import { MagnifyingGlassIcon, TrashIcon } from "@heroicons/react/24/outline";
import { Action, Button, Chain } from "@sablier/v2-components/molecules";
import { chains } from "@sablier/v2-constants";
import { useChainData } from "@sablier/v2-hooks";
import { useT } from "@sablier/v2-locales";
import { _ } from "@sablier/v2-mixins";
import { useFormPrepare } from "../logic";

const WrapperPartial = styled.div`
  ${(props) => props.theme.styles.row}
  & {
    width: 100%;
    padding: calc(${(props) => props.theme.sizes.edge} * 1)
      ${(props) => props.theme.sizes.modalEdge};
    column-gap: ${(props) => props.theme.sizes.edge};
    border-top: 2px solid ${(props) => props.theme.colors.border};
  }
`;

const Suggestion = styled.div`
  ${(props) => props.theme.styles.row}
  & {
    color: ${(props) => props.theme.colors.gray200};
    column-gap: 6px;
    cursor: pointer;

    &:hover,
    &:active {
      p {
        text-decoration: underline;
        text-decoration-style: dashed;
      }
    }

    p {
      ${(props) => props.theme.styles.textParagraphMini}
      & {
        text-decoration: underline;
        text-underline-offset: 2px;
      }
    }
  }
`;

const Actions = styled.div`
  ${(props) => props.theme.styles.row}
  & {
    column-gap: calc(${(props) => props.theme.sizes.edge} * 1 / 2);
  }
`;

const Wrapper = styled(WrapperPartial)`
  ${(props) => props.theme.medias.maxMD} {
    padding: calc(${(props) => props.theme.sizes.edge} * 1)
      calc(${(props) => props.theme.sizes.edge} * 3 / 2);
  }
  ${(props) => props.theme.medias.maxSM} {
    padding: calc(${(props) => props.theme.sizes.edge} * 3 / 4);
    *[data-component="action"] {
      & > *:first-child {
        display: none;
      }
      & > *:last-child {
        width: 100%;
      }
    }
    ${Actions} {
      width: 100%;
      & > * {
        flex: 1;
      }
    }
  }
`;

const Suggested = memo(function Suggested() {
  const { onSuggest } = useFormPrepare();
  const ethereum = useChainData(chains.mainnet.chainId);
  const { t } = useT();

  return (
    <Suggestion onClick={onSuggest}>
      <p>{t("modalCards.search.example")}</p>
      <Chain id={ethereum.chain?.chainId} size={18} />
    </Suggestion>
  );
});

function Footer() {
  const { isReady, onConfirm, onClear } = useFormPrepare();
  const { t } = useT();

  return (
    <Wrapper>
      <Action left={<Suggested />}>
        <Actions>
          <Button
            accent={"gray400"}
            appearance={"transparent"}
            onClick={onClear}
            right={TrashIcon}
            title={_.capitalize(t("words.clear"))}
          />
          <Button
            accent={"iconic400"}
            appearance={"outline"}
            onClick={onConfirm}
            isDisabled={!isReady}
            right={MagnifyingGlassIcon}
            title={_.capitalize(t("structs.showResults"))}
            titleShort={_.capitalize(t("words.search"))}
          />
        </Actions>
      </Action>
    </Wrapper>
  );
}

export default Footer;
